import React from 'react';
import { change, Field, reduxForm, getFormValues, untouch, destroy, reset } from 'redux-form';
import { useSelector } from 'react-redux';
import { CommonDropdownOutlined } from '@Components';
import { PopularCountriesContainer } from './styles';
import { POPULAR_COUNTRIES_CONSTANTS } from '../../utils/constants';
import { CLOSE_NEW_ICON } from '@Images';
import { required } from '@Utils/validation';
import {
  PopularCountriesDropdownModalFormType,
  PopularCountriesDropdownModalFormPropsType,
  PopularCountriesDropdownModalFormValuesType
} from './types';
import { IStore } from '../../../../../../store.type';
import { selectNewBeneState } from '@Redux/selectors';
import {
  RECEIVING_METHOD_BANK_ACCOUNT_FORM_NAME,
  RECEIVING_METHOD_FORM_NAME
} from '../../../../constants';
import {
  resetFormValueStateAction,
  setSelectedCountryMobileCodeAction
} from '@Redux/actions/new-bene-flow/new-bene-flow-action';
import { resetFields } from '@Utils/library';
import {
  BENE_BANK_DETAILS_FORM_NAME,
  BENE_PERSONAL_DETAILS_FORM_NAME
} from '../../../../constants/commons';

const PopularCountriesDropdownModalForm = ({
  onClose,
  dispatch
}: PopularCountriesDropdownModalFormType) => {
  const [searchText, setSearchText] = React.useState<string>('');

  const formValues = useSelector((state: IStore) =>
    getFormValues(RECEIVING_METHOD_BANK_ACCOUNT_FORM_NAME)(state)
  );

  const receivingMethodBankAccountCountryValues = useSelector(
    selectNewBeneState
  ).receivingMethodBankAccountCountryValues?.filter((opt) => {
    if (searchText) {
      // Only show countries that match search text
      return opt.type !== 'heading' && opt.text.toLowerCase().includes(searchText.toLowerCase());
    }
    return true;
  });

  const onRecipientReceivingCountryChange = (value: Record<string, any>) => {
    dispatch(resetFormValueStateAction());
    dispatch(destroy(BENE_PERSONAL_DETAILS_FORM_NAME));
    dispatch(destroy(BENE_BANK_DETAILS_FORM_NAME));
    dispatch(setSelectedCountryMobileCodeAction(value?.phone_code?.[0]));
    resetFields(
      RECEIVING_METHOD_FORM_NAME,
      { currency_code: null, payout_method: null },
      dispatch,
      change,
      untouch,
      false
    );

    dispatch(change(RECEIVING_METHOD_FORM_NAME, 'bank_account_country', value.value));
    dispatch(reset(RECEIVING_METHOD_BANK_ACCOUNT_FORM_NAME));

    onClose(false);
  };

  const onSearchChange = (value: string) => {
    setSearchText(value);
  };

  return (
    <PopularCountriesContainer>
      <div className="popular-countries-container__close-icon-container">
        <img
          src={CLOSE_NEW_ICON}
          alt="close"
          className="close-icon-container__close-icon"
          onClick={() => onClose(true)}
        />
      </div>
      <div className="popular-countries-container__form">
        <div className="popular-countries-container__container">
          <span className="container__heading">{POPULAR_COUNTRIES_CONSTANTS.heading}</span>
          <Field
            name="bank_account_country_dropdown"
            width="100%"
            type="dropdown"
            component={CommonDropdownOutlined}
            onDropdownChange={onRecipientReceivingCountryChange}
            onSearchChange={onSearchChange}
            open
            showLabel
            isFocused
            //@ts-ignore
            bindToThisObject={formValues?.bank_account_country_dropdown}
            options={receivingMethodBankAccountCountryValues}
            staticValues={receivingMethodBankAccountCountryValues}
            placeholder="Recipient receiving country"
            validate={[required]}
          />
        </div>
      </div>
    </PopularCountriesContainer>
  );
};

const PopularCountriesDropdownModal = reduxForm<
  PopularCountriesDropdownModalFormValuesType,
  PopularCountriesDropdownModalFormPropsType
>({
  form: RECEIVING_METHOD_BANK_ACCOUNT_FORM_NAME
})(PopularCountriesDropdownModalForm);

export default PopularCountriesDropdownModal;
